export const FETCH_AMBASSADORS = "FETCH_AMBASSADORS"
export const FETCH_AMBASSADORS_FAIL = "FETCH_AMBASSADORS_FAIL"